<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [header]="'COMMENTS.HISTORY.TITLE' | translate"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '36rem' }"
  [breakpoints]="{ '768px': '92vw' }"
  (onHide)="onHide()">
  @if (loading()) {
    <div class="cmt-history__loading" role="status">
      <p-progressspinner styleClass="cmt-history__spinner" />
      <span class="sr-only">{{ 'GENERAL.LOADING' | translate }}</span>
    </div>
  } @else if (hasError()) {
    <div class="cmt-history__error" role="alert">
      {{ 'COMMENTS.HISTORY.LOAD_ERROR' | translate }}
    </div>
  } @else if (isEmpty()) {
    <div class="cmt-history__empty">
      {{ 'COMMENTS.HISTORY.EMPTY' | translate }}
    </div>
  } @else {
    <ol class="cmt-history__list">
      @for (entry of entries(); track entry.id) {
        <li class="cmt-history__item">
          <header class="cmt-history__meta">
            <time
              [attr.datetime]="entry.editedAt.toISOString()"
              [attr.title]="entry.editedAt | date: 'M/d/yyyy, h:mm a'">
              {{ entry.editedAt | date: 'M/d/yyyy, h:mm a' }}
            </time>
            <span class="cmt-history__editor">
              @if (entry.editor.isDeleted) {
                {{ 'COMMENTS.AUTHOR_DELETED' | translate }}
              } @else {
                {{ entry.editor.firstName }} {{ entry.editor.lastName }}
              }
            </span>
            @if (entry.isModeration) {
              <span class="cmt-history__badge">
                <i class="pi pi-shield" aria-hidden="true"></i>
                {{ 'COMMENTS.HISTORY.MODERATOR_BADGE' | translate }}
              </span>
            }
          </header>
          @if (entry.editReason) {
            <div class="cmt-history__reason">
              <span class="cmt-history__reason-label">
                {{ 'COMMENTS.HISTORY.REASON_LABEL' | translate }}:
              </span>
              <span>{{ entry.editReason }}</span>
            </div>
          }
          @if (entry.attachmentsAddedNames.length > 0) {
            <div class="cmt-history__attachments cmt-history__attachments--added">
              <i class="pi pi-plus-circle" aria-hidden="true"></i>
              <span class="cmt-history__attachments-label">
                {{ 'COMMENTS.HISTORY.ATTACHMENTS_ADDED' | translate }}:
              </span>
              <span class="cmt-history__attachments-names">
                {{ entry.attachmentsAddedNames.join(', ') }}
              </span>
            </div>
          }
          @if (entry.attachmentsRemovedNames.length > 0) {
            <div class="cmt-history__attachments cmt-history__attachments--removed">
              <i class="pi pi-minus-circle" aria-hidden="true"></i>
              <span class="cmt-history__attachments-label">
                {{ 'COMMENTS.HISTORY.ATTACHMENTS_REMOVED' | translate }}:
              </span>
              <span class="cmt-history__attachments-names">
                {{ entry.attachmentsRemovedNames.join(', ') }}
              </span>
            </div>
          }
          <div class="cmt-history__previous">
            <div class="cmt-history__previous-label">
              {{ 'COMMENTS.HISTORY.PREVIOUS_BODY' | translate }}
            </div>
            <div class="cmt-history__previous-body" [innerHTML]="renderBody(entry.previousBodyMarkdown)"></div>
          </div>
        </li>
      }
    </ol>
  }
</p-dialog>
